import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Filler);

const LineChart = ({
  labels,
  data,
  fillColor = "rgba(0, 204, 255, 0.2)",
  borderColor,
  className,
}) => {
  const chartData = {
    labels,
    datasets: [
      {
        label: "My Data",
        data,
        fill: true, // Enable area filling
        backgroundColor: fillColor, // Set fill color
        borderColor: borderColor, // Set line color
        pointRadius: 0, // Hide data points (optional)
        tension: 0.35,
        // segment: {
        //   curve: "monotoneY",
        //   tension: 0.9, // High tension for pronounced wave
        // },
      },
    ],
  };

  const chartOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: false,
        ticks: {
          callback: function (value) {
            return `${value}M AUD`;
          },
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return <Line data={chartData} options={chartOptions} className={className} />;
};

export default LineChart;
